<template>
  <div class="app-wrapper">
    <!-- <Head /> -->
    <div class="layout-header_wrapper">
      <Banner />
      <HeaderNav :data="headerNavigation" />
    </div>
    <div class="app-main">
      <!-- <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" /> -->
      <router-view />
    </div>
    <!-- 友情链接 -->
    <!-- <Blogroll /> -->
    <foot />
    <!-- 侧边栏广告 -->
    <SideNav />

    <div class="scene-box">
      <!-- <canvas id="scene" class="scene" @click="jumpToSearch" /> -->
      <img v-if="istuzi" :src="cfg.ossDomain + '/tuzi1.gif'" class="scene" alt="" @click="isInputShow=true">
      <img v-else :src="cfg.ossDomain + '/tuzi2.gif'" class="scene" alt="" @click="isInputShow=true">
      <img v-if="shouldShowSceneBg" :src="cfg.ossDomain + '/tuzibgimg.png'" alt="" class="scene-bg" @click="isInputShow=true">
      <div v-if="isInputShow" class="input-box">
        <div class="box">
          <div class="title">在这里写下你想查询的问题：</div>
          <textarea v-model="keyword" class="input" placeholder="请输入内容" />
          <div class="btn" @click="jumpToSearch">点击破案</div>
          <i class="el-icon-close" @click="isInputShow=false" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Banner, Foot } from './components';
import HeaderNav from '@/components/HeaderNav';
import SideNav from '@/components/SideNav';
import { getNavigation } from '@/api/common';
// import { InitLive2dModel } from '../../public/live2d/initLive2dModel';

export default {
  name: 'Layout',
  components: {
    Banner,
    HeaderNav,
    Foot,
    SideNav
  },
  data() {
    return {
      columnId: '',
      sideBardata: [],
      headerNavigation: [],
      istuzi: true,
      keyword: '',
      isInputShow: false,
      isMobile: false
    };
  },
  computed: {
    shouldShowSceneBg() {
      // 如果是手机端，则依赖 isInputShow；如果是 PC 端，则永远显示 (true)
      return this.isMobile ? this.isInputShow : true;
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.getHeaderNav();
    /* new InitLive2dModel(document.getElementById('scene')) */
    setInterval(() => {
      this.istuzi = !this.istuzi;
    }, 2000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    jumpToSearch() {
      this.$router.push(`/searchNew?keyword=${this.keyword}`)
    },
    key() {
      return this.route.path;
    },
    handleSelect(key, keyPath) {
      //   this.columnId = key;
      //   this.page = 1;
      if (key === '999') {
        this.$router.push('/home');
      } else {
        this.$store.commit('SET_PlAT_FROM_Array', keyPath);
        this.$router.push('/subPage');
      }
      //   this.getNewList();
    },
    // 处理成树结构。
    formatData(data, breadcrumbList = []) {
      data.forEach(item => {
        const currentBreadcrumbList = [...breadcrumbList, item.name];

        item.breadcrumbList = currentBreadcrumbList;

        if (
          item.childList &&
          Array.isArray(item.childList) &&
          item.childList.length
        ) {
          this.formatData(item.childList, item.breadcrumbList);
        }
      });
    },
    getHeaderNav() {
      getNavigation().then(res => {
        let data = JSON.parse(res.data.value)
        data = data.filter((item) => item.isTab === 1).map(v => {
          return {
            id: v.code,
            name: v.text,
            isTab: v.isTab,
          }
        });
        data.unshift({ id: 999, name: '首页' });
        //data.splice(data.findIndex(e => e.id === 1007), 1)
        this.headerNavigation = data;
        console.log('headerTabList = ' + JSON.stringify(this.headerNavigation));
      })
    }
  }
};
</script>

<style scoped lang="less">
.app-main {
  width: 1200px;
  margin: 0 auto;
}
.app-wrapper {
  width: 100%;
  max-width: 100%;
}
.layout-header_wrapper{
  position: relative;
  width: 100%;
  max-width: 100%;
  --headernav-overlap: 18px;
}
.scene-box {
  position: fixed;
  left: 0px;
  bottom: 0px;
  z-index: 99;
  display: flex;
  .scene {
    width: 250px;
    height: 250px;
    position: relative;
    z-index: 99;
  }
  .scene-bg {
    width: 250px;
    height: 250px;
    position: absolute;
    left: 0;
    bottom: 80px;
    z-index: 98;
  }
  .input-box {
    width: 400px;
    height: 250px;
    box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.2);
    background: #008BF2;
    border-radius: 10px;
    padding: 8px;
    .box {
      background: #E7F4FE;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      padding: 15px 15px;
      .title {
        font-size: 20px;
        color: #333333;
      }
      .input {
        width: 100%;
        height: 100px;
        resize: none;
        outline: none;
        border: none;
        border-radius: 10px;
        padding: 10px;
        font-size: 16px;
        margin: 15px 0;
      }
      .btn {
        background: #008BF2;
        color: #FFFFFF;
        width: fit-content;
        padding: 10px 20px;
        border-radius: 10px;
        margin-left: auto;
        cursor: pointer;
      }
      .el-icon-close {
        position: absolute;
        right: 10px;
        top: 10px;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .app-main {
    width: 100%;
    max-width: 100%;
    padding: 0;
    overflow-x: hidden;
    touch-action: pan-y;
  }
  .app-wrapper {
    overflow-x: hidden;
    touch-action: pan-y;
  }

  .scene-box {
    position: fixed;
    left: 0px;
    bottom: 0px;
    z-index: 99;
    display: flex;
    .scene {
      width: 72px;
      height: 72px;
      left: -8px;
      position: relative;
      z-index: 99;
    }
    .scene-bg {
      width: 125px;
      height: 125px;
      position: absolute;
      left: 0;
      bottom: 80px;
      z-index: 98;
    }
    .input-box {
      width: 200px;
      height: 150px;
      box-shadow: 0px 8px 10px 0px rgba(0, 0, 0, 0.2);
      background: #008BF2;
      border-radius: 10px;
      padding: 8px;
      z-index: 999;
      .box {
        background: #E7F4FE;
        width: 100%;
        height: 100%;
        border-radius: 10px;
        padding: 15px 15px;
        .title {
          font-size: 12px;
          color: #333333;
        }
        .input {
          width: 100%;
          height: 50px;
          resize: none;
          outline: none;
          border: none;
          border-radius: 10px;
          padding: 10px;
          font-size: 10px;
          margin: 5px 0;
        }
        .btn {
          background: #008BF2;
          color: #FFFFFF;
          width: 50px;
          height: 20px;
          padding: 2px 4px;
          font-size: 10px;
          border-radius: 5px;
          margin-left: auto;
          cursor: pointer;
        }
        .el-icon-close {
          position: absolute;
          right: 10px;
          top: 10px;
        }
      }
    }
  }
}
</style>
